import { axios } from '@pukka/auth';
import { MOKA_GOAUTH_SERVICE } from '@pukka/common/constants';

import { OutletModel } from '../models';

const OUTLETS_URL = `${MOKA_GOAUTH_SERVICE}/business-service/v4/businesses/outlets`;

async function getOutletList(params?: object): Promise<OutletModel.Outlet[]> {
  const resp = await axios.get(OUTLETS_URL, { params: { ...params, size: 99999 } });

  return resp.data.data;
}

export { OUTLETS_URL, getOutletList };
